/** Auto-generated by scripts/build-data.ts — do not edit. */
export const catalogContentHash = "e3836f9b31bb4269" as const;
export const catalogBuiltAt = "2026-10-21T12:22:17.880Z" as const;
